// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"f767a10a","458":"4fcc3895","591":"61290535","605":"af1b6c62","700":"8fa90af6","840":"88a2ddba","859":"21b561b0","946":"1301c922"}[chunkId] + ".chunk.js";
};